import axios from '../axios';
// 组织列表分页信息
export const getSysTissuePage = data => {
  return axios({
    url: '/api/sys/getSysTissuePage',
    method: 'post',
    data
  })
};
// 组织删除
export const deleteSysTissues = data => {
  return axios({
    url: '/api/sys/deleteSysTissues',
    method: 'post',
    data
  })
};
export const saveSysTissue = data => {
  // 组织增
  if (!data.id) {
    return axios({
      url: '/api/sys/saveSysTissue',
      method: 'post',
      data
    })
  } else {
    // 职位改
    return axios({
      url: '/api/sys/updateSysTissue',
      method: 'post',
      data
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/moudules/Organization.js